import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../../json_query';
import { IOffer, offerHelper } from '../../../../offer';
import { getOfferExtra } from '../../../../tracking/getOfferExtra';
import { TUser } from '../../../../types/user';
import { dealTypeFromJsonQuery } from '../../../../utils/category';
import { getOfferListingType, getExtendedOfferEventExtra } from '../../../../utils/offer/tracking';
import {
  getDealType,
  getHeadline,
  getObjectTypeWithCategory,
  getObjectTypeWithJsonQuery,
  getOfferParentId,
} from '../../../../utils/trackings';

export function trackBlockedEarlyAccessPhoneClick(
  offer: IOffer,
  position: number,
  jsonQuery: IJsonQuery,
  user: TUser,
  offersQty: number,
  queryString: string,
  blockType: string,
  source?: string,
) {
  const { top3Place, ...analyticsInfo } = offerHelper(offer).getAnalyticsInfo();
  const parentId = getOfferParentId(offer, jsonQuery);
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  let extra = getOfferExtra(offer) || {};

  if (parentId) {
    extra = {
      ...extra,
      parentId,
    };
  }

  if (offer.contextToken) {
    extra = {
      ...extra,
      context_token: offer.contextToken,
    };
  }

  const product = {
    ...analyticsInfo,
    cianId: offer.cianId,
    dealType: getDealType(dealType),
    headline: getHeadline(offer),
    hiddenBase: Boolean(offer.isInHiddenBase),
    objectType: getObjectTypeWithCategory(offer.category),
    owner: Boolean(offer.isByHomeowner),
    ownerCianId: offer.cianUserId,
    ownerId: offer.userId,
    photosCount: offer.photos ? offer.photos.length : 0,
    position,
    published: offer.status === 'published',
    variant: analyticsInfo.variant ? analyticsInfo.variant.split('/') : undefined,
    ...(top3Place && { top3Place }),
    consultant: offer.isDealRequestSubstitutionPhone,
    extra,
  };

  const actionName = 'Blocked_listing_early_access';

  const pageNumber = window.location.search
    .substr(1)
    .split('&')
    .find(queryPair => /^p$/.test(queryPair.split('=')[0]));

  const extendedOfferEventExtra = getExtendedOfferEventExtra(offer);

  ca('eventEbc', {
    name: 'oldevent',
    category: 'Phones',
    action: actionName,
    label: offer.gaLabel,

    user: {
      cianUserId: user.isAuthenticated ? user.id : undefined,
      userId: user.isAuthenticated ? user.userId : undefined,
      email: user.isAuthenticated ? user.email : undefined,
      type: user.isAuthenticated && user.userType ? user.userType : 'not_authorized',
    },

    page: {
      pageType: 'Listing',
      region: jsonQuery.region ? String(jsonQuery.region.value[0]) : '1',
      objectType: getObjectTypeWithJsonQuery(jsonQuery),
      dealType: getDealType(dealType),
      siteType: 'desktop',
      sortType: (jsonQuery.sort && jsonQuery.sort.value) || 'default',
      listingType: getOfferListingType(offer),
      ...extendedOfferEventExtra,
      offersQty,
      queryString,
      pageNumber: pageNumber ? Number(pageNumber.split('=')[1]) : 1,
      extra: {
        ...extendedOfferEventExtra.extra,
        block_type: blockType,
        source,
      },
    },

    products: [product],

    searchConditions: jsonQuery,
  });
}
